import React from 'react'
import { TaskCard } from '../../types/task-board'

interface TaskCardPriorityProps {
  card: TaskCard
  onUpdatePriority: (priority: number) => Promise<void>
}

export const TaskCardPriority: React.FC<TaskCardPriorityProps> = ({ card, onUpdatePriority }) => {
  const getPriorityColor = (priority: number) => {
    switch (priority) {
      case 0: return '#6c757d' // Normalny - szary
      case 1: return '#28a745' // Niski - zielony
      case 2: return '#17a2b8' // Średni - niebieski
      case 3: return '#ffc107' // Wysoki - żółty
      case 4: return '#dc3545' // Krytyczny - czerwony
      default: return '#6c757d'
    }
  }

  const getPriorityLabel = (priority: number) => {
    switch (priority) {
      case 0: return 'Normalny'
      case 1: return 'Niski'
      case 2: return 'Średni'
      case 3: return 'Wysoki'
      case 4: return 'Krytyczny'
      default: return 'Normalny'
    }
  }

  return (
    <div style={{ border: '1px solid #e9ecef', borderRadius: '5px', marginBottom: '20px', overflow: 'hidden' }}>
      <div style={{ backgroundColor: '#f8f9fa', padding: window.innerWidth < 768 ? '8px 10px' : '10px 15px', borderBottom: '1px solid #e9ecef' }}>
        <h4 style={{ fontSize: window.innerWidth < 768 ? '15px' : '16px', fontWeight: 600, margin: 0 }}>
          Priorytet
        </h4>
      </div>
      <div style={{ padding: window.innerWidth < 768 ? '10px' : '15px' }}>
        <select
          value={card.priority ?? 0}
          onChange={async (e) => await onUpdatePriority(parseInt(e.target.value))}
          style={{ width: '100%', padding: '8px 10px', fontSize: '14px', borderRadius: '4px', border: '1px solid #ced4da', boxSizing: 'border-box' }}
        >
          <option value={0}>Normalny</option>
          <option value={1}>Niski</option>
          <option value={2}>Średni</option>
          <option value={3}>Wysoki</option>
          <option value={4}>Krytyczny</option>
        </select>
        <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
          <div style={{
            backgroundColor: getPriorityColor(card.priority ?? 0),
            color: 'white',
            padding: '2px 8px',
            borderRadius: '12px',
            fontSize: '12px'
          }}
          >
            {getPriorityLabel(card.priority ?? 0)}
          </div>
        </div>
      </div>
    </div>
  )
}
